import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=70aa2e42&lang=html&"
import script from "./ProductsList.vue?vue&type=script&lang=js&"
export * from "./ProductsList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductsList.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "6d35b2ee"
  
)

export default component.exports